module.exports = __webpack_public_path__ + "static/media/WarningIcon.d62f62ad.svg";